import { render, staticRenderFns } from "./FactoryList.vue?vue&type=template&id=136cf9f1&"
import script from "./FactoryList.vue?vue&type=script&lang=js&"
export * from "./FactoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports